import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const MustardIcon = ({
  innerColor = '#fefefe',
  outerColor = '#c69838',
  ...props
}: AllergnIconProps) => {
  const style = {
    fill: outerColor,
  };

  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_123"
        data-name="Grupo 123"
        transform="translate(-117.5 -2094)"
      >
        <g
          id="Rectángulo_16"
          data-name="Rectángulo 16"
          transform="translate(117.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="mustard" transform="translate(126.59 2099.747)">
          <path
            id="Trazado_9092"
            data-name="Trazado 9092"
            d="M119.028,10.69,117.3,5.132h.472V2.4H116.45L115.7,0h-1.831l-.745,2.4h-1.323V5.132h.472L110.55,10.69a3.714,3.714,0,0,0,3.546,4.816h1.387a3.713,3.713,0,0,0,3.546-4.816ZM114.542.909h.493L115.5,2.4H114.08Zm-1.828,2.4h4.15v.918h-4.15Zm5.027,10.15a2.779,2.779,0,0,1-2.259,1.142H114.1a2.8,2.8,0,0,1-2.678-3.638l1.812-5.828h3.119l1.812,5.828a2.779,2.779,0,0,1-.42,2.5Z"
            transform="translate(-110.379 0)"
          />
          <path
            id="Trazado_9093"
            data-name="Trazado 9093"
            d="M174.822,253.864a1.889,1.889,0,0,0-3.607,0l-.7,2.253a1.877,1.877,0,0,0,.293,1.7,1.925,1.925,0,0,0,1.538.76h1.346a1.925,1.925,0,0,0,1.538-.76,1.877,1.877,0,0,0,.293-1.7Zm-.32,3.409a1.013,1.013,0,0,1-.811.4h-1.346a1.013,1.013,0,0,1-.811-.4.978.978,0,0,1-.153-.886l.7-2.253a.98.98,0,0,1,1.872,0l.7,2.253A.978.978,0,0,1,174.5,257.273Z"
            transform="translate(-168.608 -244.888)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default MustardIcon;
